import React, { useEffect, useState, useRef } from 'react';
import { Box, HStack, VStack } from 'native-base';
import { useDutchieStore, useTheme } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { FilterView } from './FilterView';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { Button } from '~/shared/Theme';

type FilterDrawerProps = {
	isDrawerOpen: boolean;
    setIsDrawerOpen: (value: boolean) => void;
};

export const FilterDrawer = ({
    isDrawerOpen,
    setIsDrawerOpen
}: FilterDrawerProps) => {

    const { filters, setFilters } = useDutchieStore();

    const {
        radius_md,
        background_primary,
        panel,
        panel_text,
        primary,
    } = useTheme();

    const baseHeight = useRef<HTMLDivElement>();
    const BOTTOM_NAV_HEIGHT = 75;

    const [yPosition, setYPosition] =
        useState<number | null>(null);

    useEffect(() => {

        if (baseHeight.current) {
            setYPosition(baseHeight.current.getBoundingClientRect().top);
        }
    }, []);

    return (
        <Box
            justifyContent={'center'}
            alignItems={'center'}
            position='fixed'
            top={100}
            left={'25%'}
            right={0}
            bottom={0}
            width={'100%'}
            zIndex={9999}
        >
            <VStack
                ref={baseHeight}
                position={'absolute'}
                overflowY={'auto'}
                backgroundColor={panel}
                color={panel_text}
                top={0}
                right={0}
                left={'30%'}
                width={'40%'}
                zIndex={2}
                py={4}
                space={4}
                height={window.innerHeight - yPosition - BOTTOM_NAV_HEIGHT}
                borderBottomLeftRadius={radius_md}
            >
                <HStack px={4} alignItems={'center'} justifyContent={'space-between'}>
                    <Caption fontSize={18}>
                        filters
                    </Caption>
                    <Button
                        variant={'text'}
                        modifier={'unlocked'}
                        onPress={() => setIsDrawerOpen(false)}
                    >
                        <SpIcon size={18} color={primary} icon={faClose} />
                    </Button>
                </HStack>
                <FilterView
                    filters={filters}
                    setFilters={setFilters}
                    setShowFilters={() => {

                        setIsDrawerOpen(!isDrawerOpen);
                    }}
                />
            </VStack>

            { isDrawerOpen && (
                // Background layer
                <Button
                    variant={'text'}
                    modifier={'unlocked'}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1,
                        backgroundColor: background_primary?.slice(0, 7) + '80',
                        height: window.innerHeight
                    }}
                    onPress={() => setIsDrawerOpen(false)}
                />
            )}
        </Box>
    );
};

export default FilterDrawer;
